import { isSmartPhone, RoundedOffAmount } from '../../utilities/helper';
import React from 'react';
import TransactionItemWeb from './index_web';
import TransactionItemMWeb from './index_mWeb';
import useTheme from '../../utilities/hooks/theme';

interface Props {
  item: any;
  isWithdraw: boolean;
}

const TransactionItem = ({ item, isWithdraw }: Props) => {
  const { AccountTheme: theme } = useTheme();
  const {
    amount = 0,

    status = '',
    isBonus = false,
    isCashback = false,
    isCashBackExpired = false
  } = item;

  const newAmount = RoundedOffAmount(amount);
  const statusColor =
    status === 'failure' ||
    status === 'rejected' ||
    status === 'pending' ||
    status === 'cancelled' ||
    isCashBackExpired
      ? theme.transactionDebit
      : status === 'requested'
      ? theme.transactionPending
      : theme.transactionCredit;
  const statusText =
    status == 'success'
      ? isWithdraw
        ? 'Success'
        : isBonus
        ? 'Bonus Added'
        : isCashback
        ? 'Cashback Added'
        : 'Cash Added'
      : status === 'pending'
      ? 'Pending'
      : status == 'failure' || status == 'pending'
      ? 'Failed'
      : status === 'expired'
      ? 'Cashback Expired'
      : status.charAt(0).toUpperCase() + status.slice(1);

  return (
    <>
      {isSmartPhone ? (
        <TransactionItemMWeb
          newAmountText={newAmount}
          statusText={statusText}
          item={item}
          statusColor={statusColor}
          // currencyIcon={currencyIcon}
        />
      ) : (
        <TransactionItemWeb
          item={item}
          isWithdraw={isWithdraw}
          statusText={statusText}
          statusColor={statusColor}
        />
      )}
    </>
  );
};
export default React.memo(TransactionItem);
